import { ThreadItem } from '@/models/thread';
import { FC, ReactNode } from 'react';
import ItemContext from './ItemContext';

interface ItemProviderProps {
  item: ThreadItem;
  isLast: boolean;
  children: ReactNode;
}
export const ItemProvider: FC<ItemProviderProps> = ({
  item,
  isLast,
  children,
}) => {
  return (
    <ItemContext.Provider value={{ item, isLast }}>
      {children}
    </ItemContext.Provider>
  );
};
